export default __webpack_public_path__ + "static/media/bg.231fcc50.webp";